<script lang="ts">
	import { onMount } from 'svelte';
	import {
		LOGO_LINES_WITHOUT_LAST_A,
		LAST_A_LINES,
		A_PERSON_FRAMES,
		CARTWHEEL_ANIMATION_SEQUENCE,
		ANIMATION_CONFIG,
		type FrameKey
	} from './ascii-frames';

	let waveOffsets = $state<number[]>(new Array(ANIMATION_CONFIG.totalColumns + 4).fill(0));
	let showPerson = $state(false);
	let currentFrame = $state<FrameKey>('stand');
	let personX = $state(0);
	let animationDone = $state(false);

	onMount(() => {
		const { totalColumns, waveDuration, waveOffset, waveResetDelay } = ANIMATION_CONFIG;
		const columnDelay = waveDuration / totalColumns;

		// Wave animation
		for (let col = 0; col < totalColumns; col++) {
			setTimeout(
				() => {
					waveOffsets[col] = waveOffset;
					waveOffsets = [...waveOffsets];
					setTimeout(() => {
						waveOffsets[col] = 0;
						waveOffsets = [...waveOffsets];
					}, waveResetDelay);
				},
				(col * columnDelay) / 3
			);
		}

		// Start person animation after wave
		setTimeout(
			() => {
				showPerson = true;

				let totalDelay = 0;
				CARTWHEEL_ANIMATION_SEQUENCE.forEach(({ frame, x, duration }) => {
					setTimeout(() => {
						currentFrame = frame;
						personX = x;
					}, totalDelay);
					totalDelay += duration;
				});

				setTimeout(() => {
					showPerson = false;
					animationDone = true;
				}, totalDelay + 100);
			},
			waveDuration / 2 + 200
		);
	});

	let lastALines = $derived(
		animationDone || !showPerson ? LAST_A_LINES : A_PERSON_FRAMES[currentFrame]
	);
</script>

<div class="font-mono text-xs leading-tight overflow-hidden" style="color: var(--term-primary);">
	<div class="flex">
		<pre class="leading-tight">{#each LOGO_LINES_WITHOUT_LAST_A as line, _lineIdx}<div
					class="flex">{#each line.split('') as char, charIdx}<span
							class="inline-block transition-transform duration-150 ease-out"
							style="transform: translateY({waveOffsets[charIdx]}px)"
							>{char === ' ' ? '\u00A0' : char}</span
						>{/each}</div>{/each}</pre>
		<pre
			class="leading-tight transition-transform duration-75 ease-linear"
			style="transform: translateX({showPerson && !animationDone
				? personX
				: 0}px)">{#each lastALines as aLine}<span class="block">{aLine}</span>{/each}</pre>
	</div>
</div>
